import _export from '../internals/export.js';
import sameValue from '../internals/same-value.js';

var $ = _export;
var is = sameValue; // `Object.is` method
// https://tc39.es/ecma262/#sec-object.is

$({
  target: 'Object',
  stat: true
}, {
  is: is
});
